import { validationRules } from "../../utils/validation"

export const ManagerSchema = {
    managerType: [
        validationRules.required("Manager Type is required"),
    ],
    managerEntity: [
        validationRules.required("Is this manager an individual or corporate entity? is required"),
    ],
}

export const ManagerIndividualSchema = {
    fullName: [
        validationRules.required("Full Name is required"),
    ],
    countryOfResidence: [
        validationRules.required("Country of Residence is required"),
    ],
    addressLine1: [
        validationRules.required("Registered Office Address Line 1 is required"),
    ],
    postalCode: [
        validationRules.required("Registered Office Postcode is required"),
    ],
    city: [
        validationRules.required("City is required"),
    ],
    country: [
        validationRules.required("Country is required"),
    ]
}